export default "__VITE_ASSET__C1WeHDf8__"